import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["label", "name", "options", "placeholder", "validate"];
import { useField } from 'react-final-form';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { Select } from 'foundations-components/components/Select';
import { useCallback } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export default function FFSelectControl(_ref) {
  let {
      label,
      name,
      options,
      placeholder,
      validate = () => {}
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    input: ffInput,
    meta
  } = useField(name, {
    validate
  });
  const onSelectedOptionChange = useCallback(selectedOptions => {
    ffInput.onChange(selectedOptions.value);
  }, [ffInput]);
  return /*#__PURE__*/_jsx(FormControl, Object.assign({
    error: meta.touched && meta.error,
    label: label,
    validationMessage: meta.touched && meta.error
  }, rest, {
    children: /*#__PURE__*/_jsx(Select, Object.assign({}, rest, {
      onSelectedOptionChange: onSelectedOptionChange,
      options: options,
      searchable: true,
      selectedItemsPlaceholder: placeholder,
      selectedValues: [ffInput.value]
    }))
  }));
}